(() => {
    angular
        .module('trackingCodeModule', ['ngAnimate', 'journey.canvas.srv'])
        .controller('trackingCodeCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', '$sce', '$templateCache', 'Session', ($scope, $rootScope, $timeout, canvasService, helpers, $sce, $templateCache, Session) => {

            $rootScope.$watch('translate', (func) => {
                if(func) {
                    $scope.translate = func;
                }
            });

            $rootScope.$on('displayTracking', (evt, faqViewName, token = '') => {
                $scope.tracking = true;

                if(token) {
                    $scope.token = helpers.generateTrackerScript(token);
                }
            });

            $scope.closeFaq = () => {
                $scope.tracking = false;

                // Emit showWebSiteEngagement event when user copy the code
                $rootScope.$emit('showWebSiteEngagement');
            };

            $scope.trackingShowMore = () => {
                $scope.showMore = !$scope.showMore;
            }

            $scope.copied = false;
            $scope.copiedTracking = () => {
                $scope.copied = true;
                $timeout(() => { $scope.copied = false }, 3000)
            }

            // Tracking for Website Tracking Code
            $scope.copyWebsiteTrackingCode = () => {
                Intercom('trackEvent', 'AP - Copied Tracking');
            };

            const lang = Session.getCookie('L');
            const gdpr = {
                english: 'https://kb.benchmarkemail.com/is-the-website-tracking-in-automations-gdpr-compliant/',
                spanish: 'https://kb.benchmarkemail.com/es/el-seguimiento-a-sitios-web-en-automatizaciones-cumple-con-el-rgpd/',
                chineset: 'https://kb.benchmarkemail.com/cn/is-the-website-tracking-in-automations-gdpr-compliant/',
                chinese: 'https://kb.benchmarkemail.com/tw/is-the-website-tracking-in-automations-gdpr-compliant/',
                japanese: 'https://kb.benchmarkemail.com/jp/is-the-website-tracking-in-automations-gdpr-compliant/',
                italian: 'https://kb.benchmarkemail.com/it/il-tracking-del-sito-web-nelle-automazioni-e-conforme-a-gdpr/',
                french: 'https://kb.benchmarkemail.com/fr/le-suivi-du-site-web-est-il-conforme-aux-gdpr-automations/',
                brazil: 'https://kb.benchmarkemail.com/br/o-rastreamento-de-site-nas-automacoes-esta-de-acordo-com-o-rgdp/',
                german: ' https://kb.benchmarkemail.com/de/ist-website-tracking-in-automatisierungen-dsgvo-konform/'
            };
            $scope.getGdprLink = gdpr[lang] || gdpr['english'];
        }]);
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/trackingCodeController.js